import React from 'react'
import { StyleSheet } from 'react-native'

import { MotiView } from '@zet/common/components/motiView'
import { colors } from '@zet/design-system'
import { Skeleton } from 'moti/skeleton'

const LeadSummaryLoader = () => {
  return (
    <MotiView
      transition={{
        type: 'timing',
      }}
      style={[styles.padded]}
      animate={{ backgroundColor: colors.tertiary[80] }}
    >
      <Skeleton
        colorMode={'light'}
        backgroundColor={colors.tertiary[80]}
        width={'100%'}
        height={70}
      />
    </MotiView>
  )
}

export default LeadSummaryLoader

const styles = StyleSheet.create({
  padded: {
    padding: 16,
  },
})
